import type { SiteConfig } from '../../../temporary-site-config';

export const getParselySiteId = (
	parselyConfig: SiteConfig['analytics']['providers']['Parsely'],
): string | undefined => {
	const isEnabled = parselyConfig?.isEnabled;
	if (!isEnabled) {
		return undefined;
	}
	const { siteId } = parselyConfig;
	if (siteId?.length === 0) {
		return undefined;
	}
	return siteId;
};
